export default "__VITE_ASSET__D6W6LoE2__"